import { Field, Formik } from 'formik';
import React, { useEffect, useState } from 'react';

import {
  Button,
  ComboBox,
  InputMaskField,
  TextInput,
  Toggler,
} from '@components';
import { rcmbDocs, rcmbInitialValues, rcmbSchema } from '@schemas';
import { obterPeritosRequest } from '@store/requerimento/actions';
import { enviaFormRequest } from '@store/user/actions';
import { cpfResponsavelValido, parentesco as p } from '@utils';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { DadosUsuario } from './components/DadosUsuario';
import { ModalUpload } from './components/ModalUpload';
import { validaUpload } from './utils/validaUpload';

const Anexos = ({ parentesco = '' }) => {
  const anexosArray = rcmbDocs[parentesco];
  const [modalIsOpen, setModalIsOpen] = useState(false);

  return (
    <>
      <ModalUpload modalIsOpen={modalIsOpen} setModalIsOpen={setModalIsOpen} />
      {rcmbDocs.commons.map((anexo) => (
        <div className="row" key={anexo.name}>
          <div className="col-md-12 col-lg-6">
            <Field
              className="mb-3"
              name={anexo.name}
              type="file"
              label={anexo.label}
              accept="image/*,.pdf"
            >
              {({ form }) => {
                return (
                  <TextInput
                    className="mb-3"
                    name={anexo.name}
                    type="file"
                    label={anexo.label}
                    accept="image/*,.pdf"
                    multiple
                    onChange={(e) => {
                      return validaUpload({
                        anexo,
                        e,
                        form,
                        setModalIsOpen,
                      });
                    }}
                  />
                );
              }}
            </Field>
          </div>
        </div>
      ))}
      {/* {showMolestiaDocs &&
        rcmbDocs.molestiaGrave.map((anexo) => (
          <div className="row" key={anexo.name}>
            <div className="col-md-12 col-lg-6">
              <Field
                className="mb-3"
                name={anexo.name}
                type="file"
                label={anexo.label}
                accept="image/*,.pdf"
              >
                {({ form }) => {
                  return (
                    <TextInput
                      className="mb-3"
                      name={anexo.name}
                      type="file"
                      label={anexo.label}
                      accept="image/*,.pdf"
                      multiple
                      onChange={(e) => {
                        return validaUpload({
                          anexo,
                          e,
                          form,
                          setModalIsOpen,
                        });
                      }}
                    />
                  );
                }}
              </Field>
            </div>
          </div>
        ))} */}
      {(anexosArray || []).map((anexo) => (
        <div className="row" key={anexo.name}>
          <div className="col-md-12 col-lg-6">
            <Field
              className="mb-3"
              name={anexo.name}
              type="file"
              label={anexo.label}
              accept="image/*,.pdf"
            >
              {({ form }) => {
                return (
                  <TextInput
                    className="mb-3"
                    name={anexo.name}
                    type="file"
                    label={anexo.label}
                    accept="image/*,.pdf"
                    multiple
                    onChange={(e) => {
                      return validaUpload({
                        anexo,
                        e,
                        form,
                        setModalIsOpen,
                      });
                    }}
                  />
                );
              }}
            </Field>
          </div>
        </div>
      ))}

      {rcmbDocs.others.map((anexo) => (
        <div className="row" key={anexo.name}>
          <div className="col-md-12 col-lg-6">
            <Field
              className="mb-3"
              name={anexo.name}
              type="file"
              label={anexo.label}
              accept="image/*,.pdf"
            >
              {({ form }) => {
                return (
                  <TextInput
                    className="mb-3"
                    name={anexo.name}
                    type="file"
                    label={anexo.label}
                    accept="image/*,.pdf"
                    multiple
                    onChange={(e) => {
                      return validaUpload({
                        anexo,
                        e,
                        form,
                        setModalIsOpen,
                      });
                    }}
                  />
                );
              }}
            </Field>
          </div>
        </div>
      ))}
    </>
  );
};

export const RCMB = ({ title, reference }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const peritos = useSelector((state) => state.requerimento.peritos);

  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    dispatch(obterPeritosRequest());
  }, [dispatch]);

  return (
    <div className="card">
      <div className="card-body">
        <h3 className="fw-bold ts-20 mb-32">{title}</h3>

        {showForm ? (
          <>
            <p className="mb-4">
              Venho, por meio deste, requerer à Fundação Forluminas de
              Seguridade Social – FORLUZ o pagamento do benefício de Renda
              Continuada por Morte – RCM vitalício ou até 24 anos, nos termos do
              Regulamento do Plano Misto de Benefícios Previdenciários da Forluz
              (Plano B) e das normas vigentes. Para tanto, anexo a documentação
              necessária para o fim.
            </p>
            <Formik
              initialValues={rcmbInitialValues}
              validateOnMount
              validationSchema={rcmbSchema}
              onSubmit={(values) => {
                dispatch(
                  enviaFormRequest({
                    campos: values,
                    formulario: reference,
                    navigate,
                  })
                );
              }}
            >
              {({ values, handleSubmit, isValid, setFieldValue }) => {
                const parentescoFilhoEspecial =
                  values.parentesco === p.constants.FILHO_ESPECIAL;

                return (
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-md-12 col-lg-6">
                        <Field
                          className="mb-3"
                          name="parentesco"
                          component={ComboBox}
                          options={p.options.parentescosGerais.map((x) => {
                            return { value: x, label: x };
                          })}
                          label="Parentesco do beneficiário com o titular"
                          onChange={(selected) => {
                            if (selected.value !== parentescoFilhoEspecial) {
                              setFieldValue('medicoPerito', '', false);
                              setFieldValue('medicoAssistente', '', false);
                            }
                          }}
                        />
                      </div>
                    </div>

                    <div className="row form-row-flex mb-3">
                      <div className="form-row-son">
                        <Field
                          className="form-row-g-son"
                          name="cpfResponsavelLegal"
                          mask="111.111.111-11"
                          inputMode="numeric"
                          label="CPF do(a) Tutor(a)/Responsável Legal do beneficiário"
                        >
                          {({ field, form }) => (
                            <InputMaskField
                              {...field}
                              mask="111.111.111-11"
                              inputMode="numeric"
                              label="CPF do(a) Tutor(a)/Responsável Legal do beneficiário"
                              onChange={(e) => {
                                form.setFieldValue('cpfResponsavelLegal', e);
                                if (!cpfResponsavelValido(e)) {
                                  form.setFieldValue('nomeDoTutor', '');
                                }
                              }}
                            />
                          )}
                        </Field>
                      </div>

                      <div className="form-row-son">
                        <Field
                          className="form-row-g-son"
                          name="nomeDoTutor"
                          component={TextInput}
                          label="Nome do(a) Tutor(a)/Responsável Legal do beneficiário (somente se possuir)"
                          disabled={
                            !cpfResponsavelValido(values.cpfResponsavelLegal)
                          }
                        />
                      </div>
                    </div>

                    {parentescoFilhoEspecial && (
                      <div className="row mb-3 form-row-flex">
                        <p className="mb-4">
                          V. Sª deverá submeter-se a uma perícia médica. Escolha
                          o nome de um médico para agendamento da perícia.
                        </p>
                        <div className="form-row-son">
                          <Field
                            className="form-row-g-son"
                            name="medicoPerito"
                            component={ComboBox}
                            label="Médico perito"
                            options={peritos.map((medico) => {
                              return {
                                value: medico.trim(),
                                label: medico.trim(),
                              };
                            })}
                          />
                        </div>

                        <p className="mb-4">
                          Na ocasião da perícia, V. Sª poderá se fazer
                          acompanhar de um médico assistente de sua escolha. A
                          Forluz reembolsará os honorários pagos por V. Sª a
                          esse médico até o limite de R$ 570,00. Para ter
                          direito ao reembolso integral, o médico assistente
                          deverá comparecer pessoalmente à perícia, bem como
                          posteriormente para discussão do laudo. O Valor dos
                          honorários do médico assistente, somente será
                          reembolsado caso V. Sª faça opção neste formulário.
                          Levará médico assistente?
                        </p>
                        <div className="form-row-son">
                          <Field
                            className="form-row-g-son"
                            name="medicoAssistente"
                            component={ComboBox}
                            options={['Sim', 'Não'].map((op) => {
                              return { value: op, label: op };
                            })}
                            label="Médico Assistente"
                          />
                        </div>
                      </div>
                    )}

                    <div className="row">
                      <div className="col-md-12 col-lg-6">
                        <Field
                          className="mb-3"
                          name="acessoContraCheque"
                          label="Acesso ao contracheque via"
                          component={ComboBox}
                          options={['Portal', 'E-mail e portal'].map((x) => {
                            return { value: x, label: x };
                          })}
                        />
                      </div>

                      {/* <div className="col-md-12 col-lg-6">
                        <Field
                          className="mb-3"
                          name="acessoJornalForluz"
                          component={ComboBox}
                          label="Acesso Jornal Forluz"
                          options={['Digital', 'Impresso'].map((x) => {
                            return { value: x, label: x };
                          })}
                        />
                      </div> */}
                    </div>

                    <div className="row">
                      <div className="col-md-12 col-lg-6">
                        <Field
                          className="mb-3"
                          name="adiantamentoQuinzenal"
                          component={ComboBox}
                          label="Adiantamento quinzenal?"
                          options={['Sim', 'Não'].map((x) => {
                            return { value: x, label: x };
                          })}
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12 ">
                        <p className="mb-4">
                          Declaro estar ciente de que a Forluz operacionalizará
                          os descontos decorrentes de eventual relacionamento
                          com as Entidades Externas (ABCF; AEA; AIC; ANAPAR;
                          CECREMEC; CEMIG SAÚDE; CLIC; GREMIG; SEGURO DE VIDA;
                          SINDICATO JUIZ DE FORA; SINDIELETRO; SINDSUL), por
                          meio de descontos no meu benefício para repasse à(s)
                          Entidade(s), os quais poderão ser visualizados
                          mensalmente no contracheque. Declaro estar ciente,
                          ainda, de que devo contatar diretamente a Entidade à
                          qual sou filiado para o cancelamento das cobranças
                          e/ou ressarcimento de qualquer valor.
                        </p>
                        <Field
                          className="mb-3"
                          name="consentimentoDescontoFolha"
                          component={Toggler}
                          label="Consentimento descontos em folha (obrigatório)"
                        />

                        <Field
                          className="mb-3"
                          name="consentimentoAcertoFinanceiro"
                          component={Toggler}
                          createTermsField
                          label="Declaro estar ciente e concordo que, em razão de
                          falecimento do participante, ajustes poderão ser
                          feitos no meu contracheque, incluindo créditos e
                          débitos oriundos de resíduos e adiantamentos
                          anteriores ao óbito, ou valores processados
                          indevidamente após essa data."
                        />

                        <p className="mb-4">
                          Com base na Lei nº 13.709/2018 (Lei Geral de Proteção
                          de Dados Pessoais), autorizo o tratamento dos meus
                          dados pessoais e dados pessoais sensíveis para fins
                          relacionados ao meu vínculo com a FORLUZ.
                        </p>
                        <Field
                          className="mb-3"
                          name="consentimentoDadosSensiveis"
                          component={Toggler}
                          label="Consentimento dados sensíveis (obrigatório)"
                        />
                      </div>

                      <Field
                        className="mb-3"
                        name="aceiteInss"
                        component={Toggler}
                        createTermsField
                        label="Estou ciente que pessoa aposentada pela Previdência Oficial (INSS) e acometida por moléstia grave faz jus à isenção de Imposto de Renda. Este pedido poderá ser solicitado à Forluz a qualquer tempo através do formulário Isenção de Imposto de Renda disponível no menu Requerimentos. Se deferida, a isenção será processada no mês seguinte ao requerimento. "
                      />
                    </div>

                    <Anexos parentesco={values.parentesco} />

                    <Field
                      className="mb-3"
                      name="declaracaoVeracidade"
                      component={Toggler}
                      createTermsField
                      label="Declaro que as informações e os documentos por mim apresentados à Forluz são verdadeiros, estando ciente de que, caso não sejam autênticos, estarei sujeito às consequências civis e criminais cabíveis, além de autorizar a Forluz a anular o ato praticado ou o benefício concedido."
                    />

                    <hr className="mt-32 mt-xs-0 mb-32" />
                    <div className="row">
                      <div className="col-12 col-md-6 col-xl-4 ms-0 ms-md-auto">
                        <div className="d-block d-md-flex align-items-center">
                          <Button
                            disabled={!isValid}
                            className="ms-0 ms-md-3"
                            onClick={handleSubmit}
                          >
                            Continuar
                          </Button>
                        </div>
                      </div>
                    </div>
                  </form>
                );
              }}
            </Formik>
          </>
        ) : (
          <DadosUsuario
            onClick={() => {
              window.scroll(0, 0);
              setShowForm(true);
            }}
            dadosBancarios
          />
        )}
      </div>
    </div>
  );
};
